import getEquipment from "./getEquipment";
import createEquipment from "./createEquipment";
import updateEquipment from "./updateEquipment";
import deleteEquipment from "./deleteEquipment";

export { getEquipment, createEquipment, updateEquipment, deleteEquipment };

export default { getEquipment, createEquipment, updateEquipment, deleteEquipment };